<div class="form-check form-switch form-check-custom form-check-solid fs-6">
    <label class="small text-nowrap px-3" for="flexSwitchChecked">
        {{label}}

    </label>
    <input class="form-check-input" type="checkbox" id="flexSwitchChecked" [checked]="checked" [disabled]="disabled"
        (click)="toggle()" />
</div>